import { injectable, inject } from 'inversify-props';
import VueRouter from 'vue-router';
import { MealCountKey, ProgramType } from '@/models';
import { Dictionary } from 'vue-router/types/router';

export interface IRouterService {
  toString(): string;
  getParams(): Dictionary<string>;
  getMealCountKey(): MealCountKey;
}

@injectable()
export class RouterService implements IRouterService {
  @inject() router!: VueRouter;
  private sep: string = ':';

  toString(): string {
    return this.router.currentRoute.params.siteId + this.sep +
      this.router.currentRoute.params.sponsorId + this.sep +
      this.router.currentRoute.params.programId + this.sep +
      this.router.currentRoute.params.date + this.sep +
      this.router.currentRoute.params.mealType;
  }

  getParams(): Dictionary<string> {
    return this.router.currentRoute.params;
  }

  getMealCountKey(): MealCountKey {
    const params = this.router.currentRoute.params;

    const siteId = parseInt(params.siteId);
    const programId = params.programId;
    const serviceDate = params.date;
    const mealTypeId = params.mealType.toUpperCase();

    return new MealCountKey(siteId, ProgramType[programId], mealTypeId, serviceDate);
  }
}
